import { useEffect, useRef, useState } from "react";

// Defers the heavy Vimeo iframe until it scrolls near the viewport (Core Web Vitals win).
export default function LazyVimeo({ src, title, frameStyle }) {
  const ref = useRef(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || load) return;
    if (!("IntersectionObserver" in window)) { setLoad(true); return; }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) { setLoad(true); io.disconnect(); }
      },
      { rootMargin: "300px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [load]);

  return (
    <div ref={ref} style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }} data-testid="lazy-vimeo">
      {load ? (
        <iframe
          src={src}
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0, ...(frameStyle || {}) }}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          title={title}
        />
      ) : (
        <div style={{ position: "absolute", inset: 0 }} className="bg-[#1A2F25]/80 animate-pulse" />
      )}
    </div>
  );
}
